import { createSVGElementIfNotExist } from "../HorizontalTwoLineLabel";
import * as d3 from "d3";

export class TooltipController {
    uuid: string;

    tooltip: d3.Selection<Element, unknown, null, undefined>;
    constructor(uuid: string) {
        this.uuid = uuid;
    }

    create(): TooltipController {
        this.tooltip = createSVGElementIfNotExist(
            !d3.select("body").select(`#${this.uuid}`).nodes().length,
            document.body as HTMLElement,
            element => {
                return d3.select(element).append("div").attr("class", "vis-tooltip").attr("id", `${this.uuid}`);
            },
            `#${this.uuid}`
        );
        return this;
    }

    displayTooltip(): TooltipController {
        this.tooltip
            .transition()
            .duration(300)
            .styleTween("opacity", function () {
                const element = this as HTMLElement;
                if (element["_current"] === null || element["_current"] === undefined) {
                    element["_current"] = 0;
                }

                const interpolate = d3.interpolate(this["_current"], 0.9);
                element["_current"] = interpolate(0);

                return function (t) {
                    const currentOpacity = interpolate(t);

                    return `${currentOpacity}`;
                };
            });

        return this;
    }

    hideTooltip(): TooltipController {
        this.tooltip.style("display", "none");
        return this;
    }

    getElement(): Element {
        return this.tooltip.node();
    }

    locateTooltip(event: { pageX: number; pageY: number }): TooltipController {
        const element = this.getElement();

        const left = d3.max([
            40,
            d3.min([event.pageX - 50, window.innerWidth - element.getBoundingClientRect().width - 40])
        ]);

        this.tooltip
            .style("display", "inline-block")
            .style("left", left + "px")
            .style("top", function () {
                const tooltipElement = d3.select(this).node() as HTMLElement;
                const height = tooltipElement.getBoundingClientRect().height;
                return event.pageY - height * 1.2 + "px";
            });

        return this;
    }
}
